// Grid hooks, kept in separate source files from the grid components because React's fast reloading only works when
// the only thing exported from a file is a React component.

import { useRef } from 'react';
import { NavigationTriggerRef } from './NavigatableDataGrid';

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const useNavigationTriggerRef = (): NavigationTriggerRef => useRef(() => {});
